import { useRef } from 'react';

import { AnalyticsService } from '../services';

declare let window: any;

/**
 * UseTimerAnalytics gives you a timer that will send timing analytics events
 * to the cloud. You can:
 * - startTimer: start the timer, just marking the starting time
 * - stopTimer: stop the timer, sending the timing event to the cloud but keep the start time intact
 * - resetTimer: stop the timer, sending the timing event to the cloud and reset the start time
 *   to the current time - assuming then next round of timing will start from now, immediately
 *
 * @param name The event name to send to the cloud
 * @returns
 */
export const useTimerAnalytics = (name: string) => {
  const timer = useRef<number>(null);

  const startTimer = () => {
    window?.debug && console.log(`start timer ${name}`);
    const now = new Date().valueOf();
    timer.current = now;
  };

  const reportTime = () => {
    const now = new Date().valueOf();
    window?.debug && console.log(`report timer ${name}`, now - timer.current);
    AnalyticsService.timing(name, now - timer.current);
  };

  const reportAndResetTimer = () => {
    const now = new Date().valueOf();

    if (!timer.current) {
      timer.current = now;
      return;
    }
    window?.debug && console.log(`reset timer ${name}`, now - timer.current);
    AnalyticsService.timing(name, now - timer.current);
    timer.current = now;
  };

  return {
    reportAndResetTimer,
    startTimer,
    reportTime,
  };
};
